import { BaseResponse, RequestContext } from '@/api/types';

import { BadRequestError, UnauthorizedError } from './errorHandler';
/**
 * Parses the JSON returned by a network request
 */
function parseJSON<T = any>(response: Response): Promise<BaseResponse<T>> {
  return response.json();
}
export const externalConfigData: Record<string, any> = {};

/**
 * Requests a URL, returning a promise
 */
export async function request<T = any>(url: string, options?: RequestInit): Promise<T> {
  const fetchResponse = await fetch(url, {
    ...options,
    method: 'POST',
    credentials: 'include',
    body: options?.body || '{}',
  });

  const res = await parseJSON<T>(fetchResponse);
  if (res.message === 'please login') throw new UnauthorizedError(res, res);
  if (res.code > 0) {
    throw new BadRequestError(res, res);
  }

  return res.data;
}

export async function postRequest<T = any>(
  url: string,
  data: any,
  context?: RequestContext | null
): Promise<T> {
  const headers = { ...context?.headers, 'Content-type': 'application/json' };

  try {
    const fetchResponse = await fetch(url, {
      ...context,
      headers,
      method: 'POST',
      credentials: 'include',
      next: {revalidate: 600, tags: [url]},
      body: data ? JSON.stringify({...data, ...externalConfigData}) : '{}',
    });

    if (!fetchResponse) {
      throw new BadRequestError(null, null);
    }
    const res = await parseJSON<T>(fetchResponse);

    if (res.code > 0 || res.data === null) {
      throw new BadRequestError(res, res);
    }
    return res.data;
  }catch (e) {
    throw new BadRequestError(null, null);

  }
}
